import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// 🔹 Create or Update Plan
export async function createPlan(
  plan_id = "",
  plan_title = "",
  plan_price = "",
  plan_duration = "",
  plan_desc = "",
  plan_curr = "",
  plan_inv = "",
  plan_client = "",
  plan_type = "",
  plan_features = "",
  plan_img = null
) {
  try {
    const fd = new FormData();
    fd.append("plan_id", plan_id);
    fd.append("plan_title", plan_title);
    fd.append("plan_price", plan_price);
    fd.append("plan_duration", plan_duration);
    fd.append("plan_desc", plan_desc);
    fd.append("plan_curr", plan_curr);
    fd.append("plan_inv", plan_inv);
    fd.append("plan_client", plan_client);
    fd.append("plan_type", plan_type);
    fd.append("plan_features", plan_features);

    if (plan_img) {
      fd.append("plan_img", plan_img);
    }

    const response = await axios.post(`${apiBaseUrl}plan/create_plan_now`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createPlan error:", error);
    return { status: false, type: "danger", success: "Failed to create or update plan" };
  }
}

// 🔹 Delete Single Plan
export async function deletePlan(plan_id) {
  try {
    const fd = new FormData();
    fd.append("plan_id", plan_id);

    const response = await axios.post(`${apiBaseUrl}plan/del_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deletePlan error:", error);
    return { status: false, type: "danger", success: "Failed to delete plan" };
  }
}

// 🔹 Delete Multiple Plans
export async function deleteAllPlans(plan_ids = "") {
  try {
    const fd = new FormData();
    fd.append("plan_ids", plan_ids);

    const response = await axios.post(`${apiBaseUrl}plan/delete_all_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteAllPlans error:", error);
    return { status: false, type: "danger", success: "Failed to delete selected plans" };
  }
}

// 🔹 Get Plan by ID
export async function getPlanById(plan_id) {
  try {
    const fd = new FormData();
    fd.append("plan_id", plan_id);

    const response = await axios.post(`${apiBaseUrl}plan/get_plan_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPlanById error:", error);
    return { status: false, type: "danger", success: "Failed to fetch plan details" };
  }
}

// 🔹 Get Paginated Plan List (with search & filters)
export async function getPlanList(user_id, plan_type = "", page_no = "none", search_key = "") {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("plan_type", plan_type);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}plan/get_plan_list`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPlanList error:", error);
    return { status: false, type: "danger", success: "Failed to load plans" };
  }
}


// 🔹 Get All Plans (no pagination)
export async function getAllPlans() {
  try {
    const response = await axios.post(`${apiBaseUrl}plan/get_plan_all`, null, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getAllPlans error:", error);
    return { status: false, type: "danger", success: "Failed to fetch all plans" };
  }
}


// 🔹 Get Plan Report (Total Plans / Active Subscribers / Free Users)
export async function getPlanReport() {
  try {
    const fd = new FormData();

    const response = await axios.post(`${apiBaseUrl}plan/get_plan_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPlanReport error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch plan report",
      report: { total_plans: 0, active_subscribers: 0, free_users: 0 },
    };
  }
}
